export enum PageAction {
  Approve = 'Approve',
  Create = 'Create',
  Delete = 'Delete',
  Execute = 'Execute',
  Failure = 'Failure',
  Override = 'Override',
  Reject = 'Reject',
  Success = 'Success',
  Update = 'Update',
}
